module.exports = __webpack_public_path__ + "img/low-risk-en.7d5133bd.png";